import { useContext } from 'react'
import { PluginContext } from './context'
import type { PluginContextValue } from './types'

export function usePlugins(): PluginContextValue {
  const ctx = useContext(PluginContext)
  if (!ctx) throw new Error('usePlugins must be used within a PluginProvider')
  return ctx
}
